import {Pipe, PipeTransform} from '@angular/core';
import {UnitType} from "../model/unit-type";
import {unitTypeToText} from "lottery-shared";

@Pipe({
  name: 'unitTypeToText',
  standalone: true
})
export class UnitTypeToTextPipe implements PipeTransform {

  transform(unitType: UnitType): string {
    return unitTypeToText(unitType);
  }
}
